// extracted by mini-css-extract-plugin
export var actions = "_3y-0";
export var actionsContainer = "_3y-7";
export var border = "_3y-1";
export var childFullHeight = "_3y-f";
export var collapse = "_3y-2";
export var content = "_3y-a";
export var contentChild = "_3y-e";
export var fullscreen = "_3y-c";
export var hasLeftRadius = "_3y-k";
export var headerContainer = "_3y-3";
export var headerRow = "_3y-5";
export var hidePadding = "_3y-b";
export var navCollapsedGap = "_3y-l";
export var noScrollX = "_3y-m";
export var noScrollY = "_3y-n";
export var noTopPadding = "_3y-i";
export var optOutTopPadding = "_3y-d";
export var pageMain = "_3y-j";
export var pageOuter = "_3y-g";
export var pagePadding = "_3y-8";
export var pageScroll = "_3y-9";
export var profile = "_3y-o";
export var profileContainer = "_3y-p";
export var profileImage = "_3y-q";
export var profileMain = "_3y-r";
export var profileSubtitle = "_3y-t";
export var profileTitle = "_3y-s";
export var showLeftPadding = "_3y-h";
export var tabsPortalSlot = "_3y-6";
export var tabsWrapper = "_3y-4";
export var title = "_3y-u";